import * as ko from "knockout";
import "./../../bindings/bao-pager";
function FrequencyDistributionCategoryReportTabResultListViewModel(tabPage, ReportModel) {
    var self = this;
    self.TabPage = tabPage;
    self.ReportModel = ReportModel;
    self.Sorting = self.ReportModel.Sorting;
    self.PageSize = self.ReportModel.PageSize;
    self.PageIndex = self.ReportModel.PageIndex;
    self.TotalRows = self.ReportModel.TotalRows;
    self.Models = self.ReportModel.Models;
    self.Refresh = function () { };
}
;
export default FrequencyDistributionCategoryReportTabResultListViewModel;